<div #wrapper class="wrapper" style="height: 100%;">
    <div class="modal-header-wrapper">
        <div class="text-wrapper" [class.font-weight-600]="true">
            {{ 'dashboard_buy_form_title' | localise }}
        </div>
        <div class="responsive-flex-wrapper shortcuts">
            <i class="ti-close" (click)="onClose()"></i>
        </div>
    </div>

    <ng-container>
        <div class="modal-body">
            <div class="center-body">
                <div id="dropin-container"></div>

                <ng-container *ngIf="showPayButton === false">
                    <p class="loading-prep">
                        {{ 'dashboard_buy_form_loading' | localise }}
                    </p>
                </ng-container>

                <button
                        *ngIf="showPayButton"
                        class="btn btn-success btn-pay"
                        id="submit-button"
                        (click)="requestPaymentMethod()">
                    <i class="fa fa-credit-card"></i>
                    {{ 'pay_now' | localise }}
                </button>
            </div>
        </div>
    </ng-container>
</div>
